import { GaugeData } from "@models/gauges.model";


export const sampleGauges: GaugeData[] = [
    {
      id: 'quality',
      title: 'Quality',
      value: 27.7,
      min: 0,
      max: 30,
      goal: 27,
      color: '#8e6b9f',
      type: 'semi',
    },
    {
      id: 'improvement',
      title: 'Improvement Activities',
      value: 14,
      min: 0,
      max: 15,
      goal: 14,
      color: '#0a9db7',
      type: 'semi',
    },
    {
      id: 'interoperability',
      title: 'Promoting Interoperability',
      value: 23,
      min: 0,
      max: 25,
      goal: 22,
      color: '#e3a008',
      type: 'semi',
    },
    {
      id: 'total',
      title: 'Total Estimated Score',
      value: 64.7,
      min: 0,
      max: 70,
      goal: 63,
      color: '#65a30d',
      type: 'semi',
    }
  ];

  export const sampleGaugesProd: GaugeData[] = [
    {
      id: 'quality',
      title: 'Quality',
      value: 0,
      min: 0,
      max: 30,
      goal: 27,
      color: '#8e6b9f',
      type: 'semi',
    },
    {
      id: 'improvement',
      title: 'Improvement Activities',
      value: 0,
      min: 0,
      max: 15,
      goal: 14,
      color: '#0a9db7',
      type: 'semi',
    },
    {
      id: 'interoperability',
      title: 'Promoting Interoperability',
      value: 0,
      min: 0,
      max: 25,
      goal: 22,
      color: '#e3a008',
      type: 'semi',
    },
    {
      id: 'total',
      title: 'Total Estimated Score',
      value: 0,
      min: 0,
      max: 70,
      goal: 63,
      color: '#65a30d',
      type: 'semi',
    }
  ];